import { render, staticRenderFns } from "./documentList.vue?vue&type=template&id=5d6551d6&scoped=true&"
import script from "./documentList.vue?vue&type=script&lang=js&"
export * from "./documentList.vue?vue&type=script&lang=js&"
import style0 from "./documentList.vue?vue&type=style&index=0&id=5d6551d6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6551d6",
  null
  
)

export default component.exports